// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__1eGJW","bigColWidth":"Table_bigColWidth__38cDO","biggerColWidth":"Table_biggerColWidth__3cKPx","row":"Table_row__P_U6t","col":"Table_col__1dZ-R"};